export interface InventoryAvailability {
  ids: string[];
  availableIds?: string[];
  spokenForQuantity?: number;
}

/**
 * Returns the exact concrete IDs a mutation may target.
 *
 * A live availability response owns this subset. Until it resolves, rows with
 * any known reservation stay conservative because a count cannot identify
 * which physical copies are free. Rows without reservations remain fully
 * selectable, including Wants and unlisted Collection cards.
 */
export function selectableInventoryIds(item: InventoryAvailability): string[] {
  if (item.availableIds !== undefined) return item.availableIds;
  return (item.spokenForQuantity ?? 0) > 0 ? [] : item.ids;
}

/** Returns the currently actionable IDs that the user explicitly selected. */
export function selectedSelectableInventoryIds(
  item: InventoryAvailability,
  selectedIds: ReadonlySet<string>
): string[] {
  return selectableInventoryIds(item).filter((id) => selectedIds.has(id));
}
